import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UsersTab({ users, onToggleUser, onRefresh }) {
  const setRole = async (id, role) => {
    try {
      await axios.put(`${API}/admin/users/${id}/role`, { role }, { withCredentials: true });
      onRefresh();
    } catch (err) { alert(err.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="space-y-4" data-testid="admin-users-tab">
      <div>
        <h2 className="font-heading text-xl font-semibold mb-1">User Management</h2>
        <p className="text-xs text-stone-500 font-body">View, activate, or deactivate user accounts. Deactivated users cannot log in.</p>
      </div>
      <div className="bg-stone-900 rounded-xl border border-stone-800 overflow-hidden">
        <div className="hidden md:grid grid-cols-12 gap-2 px-4 py-2 text-[10px] text-stone-500 uppercase tracking-wider border-b border-stone-800 font-body">
          <span className="col-span-3">Name</span><span className="col-span-3">Email</span>
          <span className="col-span-1">Role</span><span className="col-span-2">Trees</span>
          <span className="col-span-1">CO2 (kg)</span><span className="col-span-2">Actions</span>
        </div>
        {users.map((u) => (
          <div key={u._id} className="md:grid md:grid-cols-12 md:gap-2 flex flex-col px-4 py-3 border-b border-stone-800/50 md:items-center text-sm last:border-0 gap-1"
               data-testid={`admin-user-${u._id}`}>
            <span className="md:col-span-3 truncate font-medium md:font-normal">{u.name}</span>
            <span className="md:col-span-3 text-stone-400 truncate text-xs">{u.email}</span>
            <div className="flex items-center gap-4 md:contents text-xs">
              <span className={`md:col-span-1 ${u.role === "admin" ? "text-amber-400" : "text-stone-400"}`}>{u.role}</span>
              <span className="md:col-span-2 text-emerald-400">{u.trees_planted || 0} trees</span>
              <span className="md:col-span-1 text-stone-400">{u.co2_absorbed_kg || 0}kg</span>
            </div>
            <div className="md:col-span-2 flex flex-wrap gap-1.5 items-center">
              {u.role !== "admin" && (
                <select value={u.role || "user"} onChange={(e) => setRole(u._id, e.target.value)}
                  className="text-xs bg-stone-800 border border-stone-700 rounded px-2 py-1 text-stone-200 focus:outline-none focus:border-amber-500"
                  data-testid={`user-role-${u._id}`}>
                  <option value="user">User</option>
                  <option value="moderator">Moderator</option>
                  <option value="admin">Admin</option>
                </select>
              )}
              {u.role !== "admin" && (
                <button onClick={() => onToggleUser(u._id)}
                  className={`text-xs px-2 py-1 rounded ${u.is_active === false ? "bg-red-600/20 text-red-400" : "bg-emerald-600/20 text-emerald-400"}`}
                  data-testid={`toggle-user-${u._id}`}>
                  {u.is_active === false ? "Activate" : "Deactivate"}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
